import { Injectable } from '@angular/core';
import { CartConfigService, CartRow } from 'gung-standard';
import { ListLayout } from 'gung-list';
import { ColmecCartItemComponent } from '../../components/cart/colmec-cart-item/colmec-cart-item.component';
import { ColmecCartListLayoutComponent } from '../../components/cart/colmec-cart-list-layout/colmec-cart-list-layout.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecCartConfigService extends CartConfigService {
  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart table',
        getListItemComponent: () => ColmecCartItemComponent,
        getListLayoutComponent: () => ColmecCartListLayoutComponent
      }
    ];
  }
}
